var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLongDuration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M15 2v14a2 2 0 0 1-2 2H5V4a2 2 0 0 1 2-2h8Zm-1 4H6v11h7a1 1 0 0 0 .993-.883L14 16V6Zm0-3H7a1 1 0 0 0-1 1v1h8V3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLongDuration);
export default ForwardRef;